import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {EMPTY, Observable} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {Usuario} from "../models/usuario";
import {Login} from "../models/login";

@Injectable({
	providedIn: 'root'
})
export class LoginService {

	private api_url = environment.api_url + "/login";

	constructor(private http: HttpClient) { }

	loginUsuario(username: string, password: string): Observable<any> {
		return this.http.post(this.api_url, {username: username, password: password}).pipe(map((response: any) => {
			let login: Login = response;
			localStorage.setItem("auth", JSON.stringify("ad"));
			this.setSession(login);
			return response;
		}));

	}

	loginUsuarioGovBr(num_cpf: number): Promise<any>{
		return this.http.post(`${environment.api_url}/govbr/auth/login`, {num_cpf: num_cpf}).toPromise()
			.then((response: any) => {
				this.setSession(response);
				localStorage.setItem("auth", JSON.stringify("govbr"));
			}).catch((error) => {
				console.log(error.message, 'error');
			});
	}

	loginUsuarioExterno(num_cpf: number, txt_senha: string): Observable<Login> {
		let url: string = this.api_url+'/login-externo';
		return this.http.post(url, {num_cpf: num_cpf, txt_senha: btoa(txt_senha)}).pipe(map((res: any) => {

			let login: Login = res.data as Login;
			this.setSession(login);
			return login;
		}));
	}

	setSession(login: Login): void{
		localStorage.setItem("login-planmob", JSON.stringify(login));
	}

	getAuth(): Login {
		let login: Login = null;
		if(localStorage.getItem("login-planmob")){
			login = JSON.parse(localStorage.getItem("login-planmob"))  as Login;
		}
		return login;
	}

	logout() : void{
		localStorage.removeItem("login-planmob");
	}

	esqueciMinhaSenha(num_cpf: number, txt_email: string): Observable<boolean>{
		let url: string = this.api_url + "/esqueci-minha-senha";
		return this.http.post(url, {cpf: num_cpf, email: txt_email}).pipe(map((res: any) => {
			return true;
		}));
	}

	validate(token): Observable<Usuario>{
		let url: string = this.api_url + "/validate/" + token;
		return this.http.get(url).pipe(map((res: any) => {
			return res.data as Usuario;
		}));
	}

	save(usuario: Usuario): Observable<any> {
		let url: string = this.api_url;
		let http = this.http.post(url, usuario);

		http.pipe(map((res: any) => {
			return res;
		}));

		return http;
	}

	downloadDocumentoSolicitacaoAcesso(): void {
		let url: string = this.api_url + "/solicitar-acesso";
		window.open(url, "_blank");
	}

}
